import { useMutation, useQuery } from 'react-query';
import queryGetAssets from './queries/getAssets';
import queryGetSession from './queries/getSession';
import queryGetMfa from './queries/getMfa';
import queryGetQrcodeUri from './queries/getQrcodeUri';
import mutationInitializeMFa from './mutations/mutationInitializeMFa';
import mutationSendMfaDeactivationMail from './mutations/mutationSendMfaDeactivationMail';
import mutationMfaDeactivationConfirmation from './mutations/mutationMfaDeactivationConfirmation';
import mutationConnectAs from './mutations/connectAs';
import queryGetLastBuildData from './queries/getLastBuildData';

const actionsSession = {
    // Getters
    getAssets: () => useQuery(queryGetAssets()),
    getSession: (enabled = true) => useQuery(queryGetSession(enabled)),
    getMfa: () => useQuery(queryGetMfa()),
    getQrcodeUri: () => useQuery(queryGetQrcodeUri()),
    getLastBuildData: (enabled = true) => useQuery(queryGetLastBuildData(enabled)),

    // Mutations
    initializeMFA: (onSuccess, onError) => useMutation(mutationInitializeMFa(onSuccess, onError)),
    sendMfaDeactivationMail: (OnSuccess, OnError) => useMutation(mutationSendMfaDeactivationMail(OnSuccess, OnError)),
    mfaDeactivationConfirmation: (onSuccess, onError) => useMutation(mutationMfaDeactivationConfirmation(onSuccess, onError)),
    // Connect as
    connectAs: (onSuccess, onError) => useMutation(mutationConnectAs(onSuccess, onError))
};

export default actionsSession;